import React from 'react';
import { Box, Paper, Typography, Divider } from '@mui/material';
import { EmailContent as EmailContentType } from '../../types';

interface EmailContentProps {
  isLoading: boolean;
  emailContent: { content: EmailContentType } | undefined;
}

const EmailContent: React.FC<EmailContentProps> = ({ isLoading, emailContent }) => {
  if (isLoading) {
    return <Box>Loading email content...</Box>;
  }

  if (!emailContent?.content) {
    return <Box>No email content available</Box>;
  }

  const content = emailContent.content;

  return (
    <Box>
      <Typography variant="h5" gutterBottom sx={{ marginBottom: 3 }}>
        Email Content Details
      </Typography>

      <Paper sx={{ p: 4 }}>
        {/* Email Template Name */}
        <Box sx={{ marginBottom: 3 }}>
          <Typography variant="h6" color="primary" gutterBottom>
            Email Template Name
          </Typography>
          <Typography
            variant="body1"
            sx={{ padding: 2, backgroundColor: '#f5f5f5', borderRadius: 1 }}
          >
            {content.email_template_name}
          </Typography>
        </Box>

        <Divider sx={{ marginY: 3 }} />

        {/* Subject */}
        <Box sx={{ marginBottom: 3 }}>
          <Typography variant="h6" color="primary" gutterBottom>
            Subject
          </Typography>
          <Typography
            variant="body1"
            sx={{ padding: 2, backgroundColor: '#f5f5f5', borderRadius: 1 }}
          >
            {content.subject}
          </Typography>
        </Box>

        <Divider sx={{ marginY: 3 }} />

        {/* From */}
        <Box sx={{ marginBottom: 3 }}>
          <Typography variant="h6" color="primary" gutterBottom>
            From
          </Typography>
          <Typography
            variant="body1"
            sx={{ padding: 2, backgroundColor: '#f5f5f5', borderRadius: 1 }}
          >
            {content.from}
          </Typography>
        </Box>

        <Divider sx={{ marginY: 3 }} />

        {/* Body */}
        <Box>
          <Typography variant="h6" color="primary" gutterBottom>
            Body
          </Typography>
          <Box
            sx={{
              padding: 3,
              backgroundColor: '#f5f5f5',
              borderRadius: 1,
              maxHeight: '400px',
              overflow: 'auto'
            }}
            dangerouslySetInnerHTML={{ __html: content.body }}
          />
        </Box>
      </Paper>
    </Box>
  );
};

export default EmailContent;
